import React from "react";

import { Package  } from "lucide-react";

import { Card, CardContent } from "../ui/card";


import { Order } from "@/types/AppTypes";
import OrderDetailsDialog from "../orderDetailsDialog/OrderDeatilsDialog";
import { formatDate } from "@/utils/helper/dateFormat";
import { Badge } from "../ui/badge";

const OrderHistoryCard = ({
  orderHistory,
  handlePickUpOptions,
}: {
  orderHistory: Order;
  handlePickUpOptions: (data: {
    orderId: string;
    deliveryMethod: string;
    storeLocation?: string;
  }) => void;
}) => {
  // const [deliveryMethod, setDeliveryMethod] = useState<string>("home-delivery");
  // const [storeLocation, setStoreLocation] = useState<string | undefined>(undefined);


  // React.useEffect(() => {
  //   if (deliveryMethod !== "store-pickup") {
  //     setStoreLocation(undefined);
  //   }
  // }, [deliveryMethod]);

  // // Handle delivery method change
  // const handleDeliveryChange = (value: string) => {
  //   setDeliveryMethod(value);
  // };

  // // Handle store location change
  // const handleStoreChange = (value: string) => {
  //   setStoreLocation(value);
  // };

  return (
    <Card className="rounded-lg border shadow-sm overflow-hidden py-0">
      <CardContent className="flex flex-col space-y-1.5 p-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">
              Order Placed:{" "}
            {formatDate(orderHistory?.created_at)}
            </p>
            <h3 className="font-semibold tracking-tight text-lg mt-1">{"ORD-"}{orderHistory?.id?.slice(0,4)}</h3>
          </div>
          <div className="text-right">
            <p className="font-medium">
              ${(() => {
                const variant =
                  typeof orderHistory?.variant === "string"
                    ? JSON.parse(orderHistory.variant)
                    : orderHistory?.variant || {};
                return ((orderHistory?.quantity ?? 0) * (variant?.price ?? 0)).toFixed(2);
              })()}
            </p>
            <p className="text-sm text-muted-foreground">{orderHistory?.quantity ?? 0} items</p>
          </div>
        </div>

        <div className="py-4">
          <div className="flex items-center justify-between">
          <Badge  className={`${getStatusColor(orderHistory?.status) } flex items-center`}>
              <Package className="h-5 w-5 text-black/95 mr-2" />
                      {orderHistory.status?.toUpperCase() || "UNKNOWN"} 
                    </Badge>
            {/* <div className="flex items-center">
              <span className="font-medium">{orderHistory?.status ?? ""}</span>
            </div> */}
            <div className="flex gap-4 items-center">
              {/* <Button variant="outline" className="text-sm">
                View Details
              </Button> */}
               <OrderDetailsDialog order={orderHistory} sellerName="John's Electronics" storeName="TechHub Store" />
              {/* {orderHistory?.actions?.pickUpOptions === true && (
                <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
                  <PopoverTrigger asChild>
                    <Button variant="outline" className="text-sm">
                      <Store className="h-5 w-5" />
                      Pick-Up Options
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent>
                    <label className="text-sm font-medium mb-3 block">
                      Select delivery method:
                    </label>
                    <RadioGroup value={deliveryMethod} onValueChange={handleDeliveryChange}>
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem value="home-delivery" id="home-delivery" />
                        <Label htmlFor="home-delivery">Home Delivery</Label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem value="store-pickup" id="store-pickup" />
                        <Label htmlFor="store-pickup">Store Pickup</Label>
                      </div>
                    </RadioGroup>
                    {deliveryMethod === "store-pickup" && (
                      <div className="mt-4">
                        <label className="text-sm font-medium mb-2 block">
                          Select a store location:
                        </label>
                        <Select value={storeLocation ?? ""} onValueChange={handleStoreChange}>
                          <SelectTrigger className="w-[240px]">
                            <SelectValue placeholder="Choose a store" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="downtown-store">
                              <div>
                                <div className="font-medium">Downtown Store</div>
                                <div className="text-xs text-muted-foreground">0.8 miles away</div>
                              </div>
                            </SelectItem>
                            <SelectItem value="uptown-center">
                              <div>
                                <div className="font-medium">Uptown Center</div>
                                <div className="text-xs text-muted-foreground">1.2 miles away</div>
                              </div>
                            </SelectItem>
                            <SelectItem value="westside-mall">
                              <div>
                                <div className="font-medium">Westside Mall</div>
                                <div className="text-xs text-muted-foreground">2.5 miles away</div>
                              </div>
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    )}
                    <Button
                      className="mt-4 w-full"
                      disabled={deliveryMethod === "store-pickup" && !storeLocation}
                      onClick={() => {
                        handlePickUpOptions({
                          orderId: orderHistory.id,
                          deliveryMethod,
                          storeLocation,
                        });
                        setPopoverOpen(false);
                      }}
                    >
                      Confirm
                    </Button>
                  </PopoverContent>
                </Popover>
              )} */}
             
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default OrderHistoryCard;
export const getStatusColor = (status?: string | null) => {
  switch (status?.toLowerCase()) {
    case "pending":
      return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "confirmed":
      return "bg-blue-100 text-blue-800 border-blue-200";
    case "shipped":
      return "bg-purple-100 text-purple-800 border-purple-200";
    case "delivered":
      return "bg-green-100 text-green-800 border-green-200";
    case "cancelled":
      return "bg-red-100 text-red-800 border-red-200";
    default:
      return "bg-gray-100 text-gray-800 border-gray-200";
  }
};

